import styled from 'styled-components';
import React from 'react';

export interface TwoColumnTableCellProps {
  readonly children: React.ReactNode;
  readonly isTableHeader: boolean;
}

const StyledTwoColumnTableCell = styled.td`
  width: 50%;
  padding: ${(props) => props.theme.internal.size.static250} 0;
  border-bottom: ${(props) => props.theme.internal.size.border.heavy} solid
    ${(props) => props.theme.internal.separatorColor};

  &:first-child {
    padding-right: ${(props) => props.theme.internal.size.static100};
    text-align: left;
  }

  &:last-child {
    padding-left: ${(props) => props.theme.internal.size.static100};
    text-align: right;
  }
`;

export function TwoColumnTableCell({
  children,
  isTableHeader,
}: TwoColumnTableCellProps): JSX.Element {
  return (
    <StyledTwoColumnTableCell as={isTableHeader ? 'th' : 'td'}>
      {children}
    </StyledTwoColumnTableCell>
  );
}
